import {
  ExerciseFilters,
  InfiniteScrollState,
  MemberFilters,
  NoteFilters,
  TrainingPlanFilters,
  WorkoutFilters,
  WorkoutsSelectorFilters
} from '@src/state/store'

export function defaultMemberFilters (): MemberFilters {
  return {
    name: '',
    state: 'published',
    toBeDeactivated: false,
    flags: new Set([]),
    page: 1
  }
}

export function defaultMemberNoteFilters (): NoteFilters {
  return {
    startDate: undefined,
    endDate: undefined,
    word: undefined
  }
}

export function defaultWorkoutFilters (): WorkoutFilters {
  return {
    name: '',
    type: undefined,
    from: '',
    to: '',
    categories: [],
    page: 1
  }
}

export function defaultExerciseFilters (): ExerciseFilters {
  return {
    tags: {
      movement: new Set([]),
      focus: new Set([]),
      equipment: new Set([]),
      muscle: new Set([]),
      body: new Set([]),
      phase: new Set([]),
      health: new Set([]),
      category: new Set([]),
      clinical: new Set([]),
      execution: new Set([]),
      exercise: new Set([]),
      joints: new Set([]),
      range: new Set([])
    },
    name: '',
    page: 1,
    favoritesOnly: false
  }
}

export function defaultTrainingPlanFilters (): TrainingPlanFilters {
  return {
    name: '',
    type: 'all',
    page: 1
  }
}

export function defaultWorkoutSelectorFilters (): WorkoutsSelectorFilters {
  return {
    type: undefined,
    name: '',
    tags: new Set([])
  }
}

export function defaultInfiniteScrollState (): InfiniteScrollState {
  return {
    loading: true,
    displayErrorMessage: false,
    endOfPageReached: false
  }
}
